import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { customApp } from 'src/app/_configuration/configuration';
import { IBigBlueButtonSettings } from '@sv/interfaces';

@Injectable({
  providedIn: 'root'
})
export class TechCheckService {
  constructor(private http: HttpClient) {}

  async checkBBB(eventName: string) {
    const data: IBigBlueButtonSettings = {
      id: 'techcheck-' + Date.now().toString(),
      attendeeName: 'techCheck',
      attendeePassword: '123456',
      meetingName: 'TestRaum',
      isGuest: false,
      isAdmin: false,
      askAdmin: false
    };
    return await this.http
      .post<{ status: string; data: string }>(customApp.url + `/app/event/joinTechcheck?${eventName}`, data)
      .toPromise();
  }

  async checkStream() {
    return 'https://live2.streavent.de/LiveApp/play.html?name=579905586481442476734344';
  }
}
